/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["drive-toolbar{display:block;padding:14px 28px;width:100%;overflow:hidden}drive-toolbar entry-breadcrumbs{margin:0 -8px}"];
export { styles as styles };
